import { SecureWrapper, SecureIcon, SecureText } from '../layout/DonateLayout.style';

interface SecureTextAndIconProps {
  $mobile?: boolean;
}

const secureText = import.meta.env.VITE_DIRECT_PAYMENT_MODE === 'true' ? 'Secure transaction' : 'Secure donation';

function SecureTextAndIcon({ $mobile = false }: SecureTextAndIconProps) {
  return (
    <SecureWrapper>
      <SecureIcon $mobile={$mobile} alt="" />
      <SecureText $mobile={$mobile}>{secureText}</SecureText>
    </SecureWrapper>
  );
}

export default SecureTextAndIcon;
